import {
    REQUEST_ORG_UNIT_HIERARCHY,
    FETCH_ORG_UNIT_HIERARCHY_SUCCESS, 
    FETCH_ORG_UNIT_HIERARCHY_FAIL,
    REQUEST_SELECTED_ORG_UNIT_DETAILS,
    FETCH_SELECTED_ORG_UNIT_DETAILS_SUCCESS,
    FETCH_SELECTED_ORG_UNIT_DETAILS_FAIL,
    TOGGLE_SHOW_ADD_PARENT_ORG_UNIT,
    SELECT_PARENT_ORG_UNIT,
    REQUEST_ORG_UNITS,
    FETCH_ORG_UNITS_SUCCESS,
    FETCH_ORG_UNITS_FAIL,
    SEND_ADD_ORG_UNIT_PARENT,
    ADD_ORG_UNIT_PARENT_SUCCESS,
    ADD_ORG_UNIT_PARENT_FAIL,
    REQUEST_ORG_UNIT_TYPES,
    FETCH_ORG_UNIT_TYPES_SUCCESS,
    FETCH_ORG_UNIT_TYPES_FAIL,
    TOGGLE_SHOW_ADD_ORG_UNIT_TYPE,
    SELECT_ORG_UNIT_TYPE,
    SEND_ADD_ORG_UNIT_TYPE,
    ADD_ORG_UNIT_TYPE_SUCCESS,
    ADD_ORG_UNIT_TYPE_FAIL,
    TOGGLE_SHOW_ADD_ORG_UNIT_STAFF,
    REQUEST_ORG_UNIT_POSITIONS,
    FETCH_ORG_UNIT_POSITIONS_SUCCESS, 
    FETCH_ORG_UNIT_POSITIONS_FAIL,
    REQUEST_ORG_UNIT_EMPLOYEES,
    FETCH_ORG_UNIT_EMPLOYEES_SUCCESS,
    FETCH_ORG_UNIT_EMPLOYEES_FAIL,
    SELECT_ORG_UNIT_STAFF_POSITION,
    SELECT_ORG_UNIT_STAFF_EMPLOYEE,
    SEND_ADD_ORG_UNIT_STAFF,
    ADD_ORG_UNIT_STAFF_SUCCESS,
    ADD_ORG_UNIT_STAFF_FAIL,
    TOGGLE_SHOW_ADD_ORG_UNIT_CONTACT,
    REQUEST_CONTACT_TYPES,
    FETCH_CONTACT_TYPES_SUCCESS,
    FETCH_CONTACT_TYPES_FAIL,
    SEND_ADD_ORG_UNIT_CONTACT,
    ADD_ORG_UNIT_CONTACT_SUCCESS,
    ADD_ORG_UNIT_CONTACT_FAIL
} from './actionTypes';

export function fetchOrgUnitHierarchyReducer(state = {
                                                    isFetching: false,
                                                    items: [],
                                                    error: false
                                                }, action) {
    switch(action.type) {
        case REQUEST_ORG_UNIT_HIERARCHY:
            return Object.assign({}, state, {
                isFetching: true
            });
        case FETCH_ORG_UNIT_HIERARCHY_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                items: action.orgUnitHierarchy
            });
        case FETCH_ORG_UNIT_HIERARCHY_FAIL:
            return Object.assign({}, state, {
                isFetching: false,
                error: true
            });
        default:
            return state;
    }
}

export function selectOrgUnitReducer(state = {
                                        isFetching: false,
                                        orgUnitDetails: null,
                                        error: false
                                    }, action) {
    switch(action.type) {
        case REQUEST_SELECTED_ORG_UNIT_DETAILS:
            return Object.assign({}, state, {
                isFetching: true
            });
        case FETCH_SELECTED_ORG_UNIT_DETAILS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                orgUnitDetails: action.orgUnitDetails
            });
        case FETCH_SELECTED_ORG_UNIT_DETAILS_FAIL:
            return Object.assign({}, state, {
                isFetching: false,
                error: true
            });
        default:
            return state;
    }
}

export function orgUnitParentReducer(state = {
                                        isAddingParent: false,
                                        parentOrgUnitIdToAdd: null,
                                        isSendingParent: false,
                                        addingParentError: false
                                    }, action) {
    switch(action.type) {
        case TOGGLE_SHOW_ADD_PARENT_ORG_UNIT:
            if (state.isAddingParent) {
                return Object.assign({}, state, {
                    isAddingParent: false,
                    parentOrgUnitIdToAdd: null
                });
            } else {
                return Object.assign({}, state, {
                    isAddingParent: true
                });
            }
        case SELECT_PARENT_ORG_UNIT:
            return Object.assign({}, state, {
                parentOrgUnitIdToAdd: action.parentOrgUnitIdToAdd
            });
        case SEND_ADD_ORG_UNIT_PARENT:
            return Object.assign({}, state, {
                isSendingParent: true
            });
        case ADD_ORG_UNIT_PARENT_SUCCESS:
            return Object.assign({}, state, {
                isSendingParent: false,
                addingParentError: false,
                isAddingParent: false,
                parentOrgUnitIdToAdd: null
            });
        case ADD_ORG_UNIT_PARENT_FAIL:
            return Object.assign({}, state, {
                isSendingParent: false,
                addingParentError: true
            });
        default:
            return state;
    }
}

export function fetchOrgUnitsReducer(state = {
                                        isFetching: false,
                                        items: [],
                                        error: false
                                    }, action) {
    switch(action.type) {
        case REQUEST_ORG_UNITS:
            return Object.assign({}, state, {
                isFetching: true
            });
        case FETCH_ORG_UNITS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                items: action.orgUnits
            });
        case FETCH_ORG_UNITS_FAIL:
            return Object.assign({}, state, {
                isFetching: false,
                error: true
            });
        default:
            return state;
    }
}

export function fetchOrgUnitTypesReducer(state = {
                                        isFetching: false,
                                        items: [],
                                        error: false
                                    }, action) {
    switch (action.type) {
        case REQUEST_ORG_UNIT_TYPES:
            return Object.assign({}, state, {
                isFetching: true
            });
        case FETCH_ORG_UNIT_TYPES_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                items: action.orgUnitTypes
            });
        case FETCH_ORG_UNIT_TYPES_FAIL:
            return Object.assign({}, state, {
                isFetching: false,
                error: true
            });
        default:
            return state;
    }
}

export function orgUnitTypeReducer(state = {
                                    isAddingType: false,
                                    orgUnitTypeIdToAdd: null,
                                    isSendingType: false,
                                    addingTypeError: false
                                    }, action) {
    switch(action.type) {
        case TOGGLE_SHOW_ADD_ORG_UNIT_TYPE:
            if (state.isAddingType) {
                return Object.assign({}, state, {
                    isAddingType: false,
                    orgUnitTypeIdToAdd: null,
                    addingTypeError: false
                });
            } else {
                return Object.assign({}, state, {
                    isAddingType: true,
                    addingTypeError: false
                });
            }
        case SELECT_ORG_UNIT_TYPE:
            return Object.assign({}, state, {
                orgUnitTypeIdToAdd: action.orgUnitTypeIdToAdd,
                addingTypeError: false
            });
        case SEND_ADD_ORG_UNIT_TYPE:
            return Object.assign({}, state, {
                isSendingType: true,
                addingTypeError: false
            });
        case ADD_ORG_UNIT_TYPE_SUCCESS:
            return Object.assign({}, state, {
                isSendingType: false,
                addingTypeError: false,
                isAddingType: false,
                orgUnitTypeIdToAdd: null
            });
        case ADD_ORG_UNIT_TYPE_FAIL:
            return Object.assign({}, state, {
                isSendingType: false,
                addingTypeError: true
            });
        default:
            return state;
    }
}

export function orgUnitStaffReducer(state = {
                                        isAddingStaff: false,
                                        positions: {
                                            items: [],
                                            isFetching: false,
                                            error: false
                                        },
                                        employees: {
                                            items: [],
                                            isFetching: false,
                                            error: false
                                        },
                                        orgUnitPositionIdToAdd: null,
                                        orgUnitEmployeeIdToAdd: null,
                                        isSendingStaff: false,
                                        addingStaffError: false
                                    }, action) {
    switch (action.type) {
        case TOGGLE_SHOW_ADD_ORG_UNIT_STAFF:
            if (state.isAddingStaff) {
                return Object.assign({}, state, {
                    isAddingStaff: false,
                    orgUnitPositionIdToAdd: null,
                    orgUnitEmployeeIdToAdd: null,
                });
            } else {
                return Object.assign({}, state, {
                    isAddingStaff: true
                });
            }
        case REQUEST_ORG_UNIT_POSITIONS:
            return Object.assign({}, state, {
                positions: {
                    ...state.positions,
                    isFetching: true
                }
            });
        case FETCH_ORG_UNIT_POSITIONS_SUCCESS:
            return Object.assign({}, state, {
                positions: {
                    isFetching: false,
                    items: action.orgUnitPositions,
                    error: false
                }
            });
        case FETCH_ORG_UNIT_POSITIONS_FAIL:
            return Object.assign({}, state, {
                positions: {
                    isFetching: false,
                    error: true
                }
            });
        case REQUEST_ORG_UNIT_EMPLOYEES:
            return Object.assign({}, state, {
                employees: {
                    ...state.employees,
                    isFetching: true
                }
            });
        case FETCH_ORG_UNIT_EMPLOYEES_SUCCESS:
            return Object.assign({}, state, {
                employees: {
                    isFetching: false,
                    items: action.orgUnitEmployees,
                    error: false
                }
            });
        case FETCH_ORG_UNIT_EMPLOYEES_FAIL:
            return Object.assign({}, state, {
                employees: {
                    isFetching: false,
                    error: true
                }
            });
        case SELECT_ORG_UNIT_STAFF_POSITION:
            return Object.assign({}, state, {
                orgUnitPositionIdToAdd: action.orgUnitPositionIdToAdd
            });
        case SELECT_ORG_UNIT_STAFF_EMPLOYEE:
            return Object.assign({}, state, {
                orgUnitEmployeeIdToAdd: action.orgUnitEmployeeIdToAdd
            });
        case SEND_ADD_ORG_UNIT_STAFF:
            return Object.assign({}, state, {
                isSendingStaff: true
            });
        case ADD_ORG_UNIT_STAFF_SUCCESS:
            return Object.assign({}, state, {
                isSendingStaff: false,
                addingStaffError: false,
                isAddingStaff: false,
                orgUnitTypeIdToAdd: null
            });
        case ADD_ORG_UNIT_STAFF_FAIL:
            return Object.assign({}, state, {
                isSendingStaff: false,
                addingStaffError: true
            });
        default:
            return state;
    }
}

export function orgUnitContactReducer(state = {
                                    isAddingContact: false,
                                    contactTypes: {
                                        items: [],
                                        isFetching: false,
                                        error: false
                                    },
                                    isSendingContact: false,
                                    addingContactError: false,
                                    addingContactSuccess: false
                                    }, action) {
    switch (action.type) {
        case TOGGLE_SHOW_ADD_ORG_UNIT_CONTACT:
            if (state.isAddingContact) {
                return Object.assign({}, state, {
                    isAddingContact: false,
                    addingContactSuccess: false
                });
            } else {
                return Object.assign({}, state, {
                    isAddingContact: true
                });
            }
        case REQUEST_CONTACT_TYPES:
            return Object.assign({}, state, {
                contactTypes: {
                    ...state.contactTypes,
                    isFetching: true
                }
            });
        case FETCH_CONTACT_TYPES_SUCCESS:
            return Object.assign({}, state, {
                contactTypes: {
                    isFetching: false,
                    items: action.contactTypes,
                    error: false
                }
            });
        case FETCH_CONTACT_TYPES_FAIL:
            return Object.assign({}, state, {
                contactTypes: {
                    isFetching: false,
                    error: true
                }
            });
        case SEND_ADD_ORG_UNIT_CONTACT:
            return Object.assign({}, state, {
                isSendingContact: true,
                addingContactSuccess: false
            });
        case ADD_ORG_UNIT_CONTACT_SUCCESS:
            return Object.assign({}, state, {
                isSendingContact: false,
                addingContactError: false,
                isAddingContact: false,
                addingContactSuccess: true
            });
        case ADD_ORG_UNIT_CONTACT_FAIL:
            return Object.assign({}, state, {
                isSendingContact: false,
                addingContactError: true,
                addingContactSuccess: false
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reduxFiles/reducers.js